import { render, staticRenderFns } from "./Components3EditModal.vue?vue&type=template&id=16bf005a"
import script from "./Components3EditModal.vue?vue&type=script&lang=js"
export * from "./Components3EditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports